export const BELL_BADGE_MAX = 99;

/** Text for the bell badge: the count, or "99+" above 99. Empty when nothing is unread. */
export function bellBadgeLabel(count: number): string {
  if (count <= 0) {
    return '';
  }

  return count > BELL_BADGE_MAX ? `${BELL_BADGE_MAX}+` : String(count);
}
